import { Service, signal } from '@angular/core';
import type { OnyxCustomAddress } from '@onyx/angular';
import type { Driver } from '../../../drivers/common/interfaces/driver';
import type { Fleet } from '../../../fleet/common/interfaces/fleet';

export interface DelegationCrew {
  primaryDriver: Driver | null;
  secondaryDriver: Driver | null;
  vehicle: Fleet | null;
  trailer: Fleet | null;
}

@Service()
export class DelegationsFormService {
  public crew = signal<DelegationCrew | null>(null);
  public driverBase = signal<OnyxCustomAddress | null>(null);
  public driverHome = signal<OnyxCustomAddress | null>(null);
  public vehicleBase = signal<OnyxCustomAddress | null>(null);
  public startDate = signal<string | null>(null);
  public startTime = signal<string | null>(null);
}
